import { create } from 'zustand'

interface IContentsModalStore {
  isOpen: boolean
  position: number
  setPosition: (position: number) => void
  setIsOpen: (isOpen: boolean) => void
}

export const useContentsModalStore = create<IContentsModalStore>((set) => ({
  isOpen: false,
  position: 1,
  setPosition: (position) => set({ position, isOpen: position === 0 }),
  setIsOpen: (isOpen) => set({ isOpen, position: isOpen ? 0 : 1 }),
}))
